import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HelperService} from "app/lib/helper.service";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {ModalService} from "app/views/modal/base_modal.component";

import { DOCUMENT } from '@angular/common';
import {ChartParams} from "../../views/chart/chart.component";
import { UserService } from "../user.service";


@Component({
	selector: 'user-charts',
	templateUrl: './user_charts.component.html'
})
export class UserChartsComponent extends BaseComponent {
	addFilterParams = {
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
		isRegDay: true,
		userType: 'user'
	};
	
	mailChart     = new ChartParams();
	regChart      = new ChartParams();
	browserChart  = new ChartParams();
	activityChart = new ChartParams();

	constructor(
		@Inject(DOCUMENT) private document,
		public eventsService: EventsService,
		public helper: HelperService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public userService: UserService,
	) {
		super(eventsService, userService, activatedRoute, filter, translate);

		this.mailChart.setOptions({
			title: this.translate.__A('users.reg_day.Mail domain'),
			type: 'pie'
		});

		this.regChart.setOptions({
			title: this.translate.__A('filterForm.regFilter'),
			type: 'pie'
		});

		this.browserChart.setOptions({
			title: this.translate.__A('users.reg_day.browsers'),
			type: 'pie'
		});
		
		this.activityChart.setOptions({
			title: this.translate.__A('users.reg_day.activity'),
		});
	}
	
	
	async getData() {
		await this.getMailChart();
		await this.getRegChart();
		await this.getBrowserChart();
		await this.getActivityChart();
	}
	
	
	async getMailChart() {
		this.mailChart.showLoader();
		
		const { charts } = await this.userService.userCharts.chart(
			this.filter.filterParams,
			'mails'
		).toPromise();
		
		this.mailChart.data = charts;
		
		this.mailChart.hideLoader();
	}
	
	
	async getRegChart() {
		this.regChart.showLoader();
		
		const { charts } = await this.userService.userCharts.chart(
			this.filter.filterParams,
			'reg'
		).toPromise();
		
		this.regChart.data = charts;
		
		this.regChart.hideLoader();
	}
	
	
	async getBrowserChart() {
		this.browserChart.showLoader();
		
		const {charts } = await this.userService.userCharts.chart(
			this.filter.filterParams,
			'browser'
		).toPromise();

		this.browserChart.data = charts;
		
		this.browserChart.hideLoader();
	}
	
	
	async getActivityChart() {
		this.activityChart.showLoader();
		const { charts } = await this.userService.userCharts.chart(
			this.filter.filterParams,
			'activity'
		).toPromise();
		this.activityChart.data = charts;
		this.activityChart.hideLoader();
	}
}
